module.exports = __webpack_public_path__ + "img/end.dd640e20.png";